import { Dimensions, DimensionValue } from 'react-native';

export const rowHeight = 78;

export const columnWidthsHeadDesktop = {
  paper: 13,
  date: 15,
  purchaseQty: 15,
  saleQty: 15,
  executedQty: 15,
  position: 15,
  operation: 12,
};

export const columnWidthsItemDesktop = {
  paper: '13%',
  date: '15%',
  purchaseQty: '15%',
  saleQty: '15%',
  executedQty: '15%',
  position: '15%',
  operation: '12%',
};

export const columnWidthsTablet = {
  column1: '27%',
  column2: '27%',
  column3: '27%',
  column4: '25%',
};

export const maxHeight = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.5
}px` as DimensionValue;

export const maxHeightMobile = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.14
}px` as DimensionValue;
